var React = require('react');

function Award (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4)"},[React.createElement("circle",{"data-name":"Ellipse 6","cx":"7","cy":"7","r":"7","transform":"translate(5 1)","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"data-name":"Tracé 6","d":"M8.21,13.89,7,23l5-3,5,3-1.21-9.12","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Award.defaultProps = {"width":"16","height":"24","viewBox":"0 0 16 24"};

module.exports = Award;

Award.default = Award;
